import React, {useEffect, useRef} from "react";
import {useStyles} from "../styles/EvenSpeakingStyle";
import {Box, Select, MenuItem, FormControl, IconButton} from "@material-ui/core";
import {inject, observer} from "mobx-react";
import {withRouter} from "react-router-dom";
import {ReactComponent as ArrowDownIcon} from '../../../../../../common/images/ArrowDownIcon.svg';
import {ReactComponent as RefreshIcon} from "../../../../../../common/images/RefreshIcon.svg";
import {ReactComponent as RefreshDisableIcon} from '../../../../../../common/images/RefreshDisableIcon.svg';
import {ReactComponent as VolumeIcon} from "../../../../../../common/images/VolumeIcon.svg";
import {ReactComponent as AddTextBoxIcon} from "../../../../../../common/images/AddTextBoxIcon.svg";
import {ReactComponent as DeleteTextBoxIcon} from '../../../../../../common/images/DeleteTextBoxIcon.svg';
import {DragDropContext, Droppable, Draggable} from "react-beautiful-dnd";
import { HighlightWithinTextarea } from 'react-highlight-within-textarea'
import EvenSpeakingEditSelector from "./EvenSpeakingEditSelector";

function EvenSpeakingSentence(props) {
    const classes = useStyles();
    const {selectedContent, evenStepSixStore, contentStore} = props;
    const speakingBoxRef = useRef(null);
    const {contents} = selectedContent;
    const {isProcessing, contentList} = evenStepSixStore;

    const onDragEnd = (result) => {
        if (!result.destination) return;
        contentList.forEach(cl => {
            const reorderedContents = Array.from(cl.contents);
            const [reorderedItem] = reorderedContents.splice(result.source.index, 1);
            reorderedContents.splice(result.destination.index, 0, reorderedItem);
            evenStepSixStore.setReorderedContents(reorderedContents, cl.languageCode);
        });
    };

    useEffect(() => {
        if (!!speakingBoxRef.current && !evenStepSixStore.speakingBoxRef) {
            evenStepSixStore.setPopoverState(true);
            evenStepSixStore.setSpeakingBoxRef(speakingBoxRef);
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [speakingBoxRef]);

    const open = Boolean(speakingBoxRef);

    const id = open ? 'simple-popover' : undefined;

    const addSpeaking = () => {
        contentList.forEach(cl => {
            const reorderedContents = Array.from(cl.contents);
            reorderedContents.splice(1, 0, {speakerName: '', text: '', voiceType: 'Man', boldStartIndex: null, boldEndIndex: null});
            evenStepSixStore.setReorderedContents(reorderedContents, cl.languageCode);
        });
    }

    const removeSpeaking = () => {
        evenStepSixStore.setDeleteFlag(true);
        contentList.forEach(cl => {
            const reorderedContents = Array.from(cl.contents);
            reorderedContents.splice(cl.contents.length - 1, 1);
            evenStepSixStore.setReorderedContents(reorderedContents, cl.languageCode);
        });
    }

    const handleChangeSpeakingText = (value, index) => {
        const updatedValue = value.replace(/\n/g, "");
        evenStepSixStore.setSpeakingContentText(updatedValue, index, contents);
    }

    const handleChangeAudio = (voiceType, text, index) => {
        contentStore.getGeneratedTTSWithAzure(selectedContent.languageCode, voiceType, text, (result) => evenStepSixStore.setSpeakingContentAudio(result, index, contents));
    }

    const handleChangeVoiceType = (voiceType, index) => {
        evenStepSixStore.setVoiceTypeByIndex(voiceType, index, contents);
    }

    return (
        !isProcessing ?
            <DragDropContext onDragEnd={onDragEnd}>
                <Droppable droppableId="droppable">
                    {(provided) => (
                        <div {...provided.droppableProps} ref={provided.innerRef}>
                            {contents?.map((content, key) => (
                                <Draggable
                                    key={key}
                                    draggableId={`item-${key}`}
                                    index={key}
                                >
                                    {(provided) => (
                                        <div
                                            ref={provided.innerRef}
                                            {...provided.draggableProps}
                                            {...provided.dragHandleProps}
                                        >
                                            <Box
                                                display={"flex"}
                                                alignItems={"center"}
                                                justifyContent={"flex-start"}
                                            >
                                                <Box display={'flex'} alignItems={'center'}
                                                     justifyContent={'flex-start'} className={classes.PaddingBox}>
                                                    <Box sx={{padding: 0}}>
                                                        <FormControl className={classes.formControl}>
                                                            <Select
                                                                value={content.voiceType}
                                                                onChange={(e) => handleChangeVoiceType(e.target.value, key)}
                                                                IconComponent={(props) => (
                                                                    <Box>
                                                                        <ArrowDownIcon  {...props} />
                                                                    </Box>
                                                                )}
                                                                MenuProps={{
                                                                    anchorOrigin: {
                                                                        vertical: "bottom",
                                                                        horizontal: "right"
                                                                    },
                                                                    transformOrigin: {
                                                                        vertical: 'top',
                                                                        horizontal: 'right',
                                                                    },
                                                                    getContentAnchorEl: null,
                                                                    className: classes.selectPopover
                                                                }}
                                                            >
                                                                <MenuItem value='Man'>성인남성</MenuItem>
                                                                <MenuItem value='Woman'>성인여성</MenuItem>
                                                                <MenuItem value='Child'>아이</MenuItem>
                                                                <MenuItem value='Elderly'>노인</MenuItem>
                                                            </Select>
                                                        </FormControl>
                                                    </Box>
                                                    <Box>
                                                        {content.audioExist ?
                                                            <IconButton style={{cursor: 'default'}}
                                                                        className={classes.iconButton}
                                                                        disableRipple>
                                                                <RefreshDisableIcon/>
                                                            </IconButton> :
                                                            <IconButton className={classes.iconButton} disableRipple
                                                                        onClick={() => handleChangeAudio(content.voiceType, content.text, key)}>
                                                                <RefreshIcon/>
                                                            </IconButton>
                                                        }
                                                    </Box>
                                                    <Box>
                                                        <Box className={classes.textListBox}
                                                             aria-describedby={id} variant="contained"
                                                             color="primary">
                                                            <HighlightWithinTextarea
                                                                style={{position: 'absolute', top: '-20px'}}
                                                                placeholder={''}
                                                                highlight={content.boldStartIndex !== null && content.boldEndIndex !== null ?
                                                                    [{
                                                                        highlight: [content?.boldStartIndex, content?.boldEndIndex],
                                                                        component: ({ children }) => {
                                                                            return <mark style={{backgroundColor: 'transparent', fontWeight: 'bold'}}>{children}</mark>;
                                                                        }
                                                                    }] : []
                                                                }
                                                                onChange={(value) => handleChangeSpeakingText(value, key)}
                                                                value={content.text}
                                                            />
                                                            <IconButton className={classes.volumeIconButton}
                                                                        onClick={() => evenStepSixStore.playAudio(content.audio, selectedContent.languageCode + '-' + content.sequence)}
                                                                        disableRipple>
                                                                    <VolumeIcon/>
                                                            </IconButton>
                                                        </Box>
                                                    </Box>
                                                    <Box>
                                                        {key === 0 ?
                                                            <IconButton className={classes.iconButton} disableRipple
                                                                        onClick={addSpeaking}>
                                                                    <AddTextBoxIcon/>
                                                            </IconButton> :
                                                            key === contents.length - 1 &&
                                                            <IconButton className={classes.iconButton} disableRipple
                                                                        onClick={removeSpeaking}>
                                                                    <DeleteTextBoxIcon/>
                                                            </IconButton>
                                                        }
                                                    </Box>
                                                </Box>
                                            </Box>
                                        </div>
                                    )}
                                </Draggable>
                            ))}
                            {provided.placeholder}
                        </div>
                    )}
                </Droppable>
            </DragDropContext> :
            <EvenSpeakingEditSelector contents={contents}/>
);
}

export default withRouter(inject('evenStepSixStore', 'contentStore')(observer(EvenSpeakingSentence)));
